import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import Bt from "./auth-manager.js";
import t from "../common/base-provider.js";
import ro from "../util/browser-detector.js";
import Ot from "./device-manager.js";
import DeviceProperties from "../Core/device-properties.js";
import { isArray as D, keys as C, validateValueIsFromEnum as ta, values as Pt } from "../util/code-utils.js";
import Mt from "./network-manager.js";
import Wt from "../request-controller.js";
import Vt from "./server-config-manager.js";
import Kt from "./session-manager.js";
import ee, { STORAGE_KEYS as s } from "./storage-manager.js";
import Gt from "./storage-manager-factory.js";
import u from "./subscription-manager.js";
import { TriggersProviderFactory as rt } from "../triggers/triggers-provider-factory.js";
import bt from "../User/user-manager.js";
import { User } from "../User/index.js";
import { parseQueryStringKeyValues as ll } from "../util/url-utils.js";
import { WindowUtils as no } from "../util/window-utils.js";
import { BRAZE_MUST_BE_INITIALIZED_ERROR as w } from "../common/constants.js";
import { SupportedOptions as $t, logger as E } from "../../shared-lib/index.js";
import _t from "../models/identifier.js";
var z = {
  _o: "allowCrawlerActivity",
  Ro: "baseUrl",
  Wo: "noCookies",
  Vo: "devicePropertyAllowlist",
  Aa: "disablePushTokenMaintenance",
  Yo: "enableLogging",
  Xo: "enableSdkAuthentication",
  qa: "manageServiceWorkerExternally",
  Zo: "minimumIntervalBetweenTriggerActionsInSeconds",
  Wh: "sessionTimeoutInSeconds",
  Vh: "appVersion",
  Kh: "appVersionNumber",
  Ma: "serviceWorkerLocation",
  ka: "safariWebsitePushId",
  Xn: "localization",
  er: "contentSecurityNonce",
  re: "allowUserSuppliedJavascript",
  Jo: "inAppMessageZIndex",
  Do: "openInAppMessagesInNewTab",
  tn: "openCardsInNewTab",
  Lh: "requireExplicitInAppMessageDismissal",
  $h: "doNotLoadFontAwesome",
  Jh: "deviceId",
  _a: "serviceWorkerScope",
  Yh: "sdkFlavor"
};
var Jt = /*#__PURE__*/function () {
  function Jt() {
    _classCallCheck(this, Jt);
    this.sn = "", this.Xh = "", this.Zh = void 0, this.Qh = null, this.on = null, this.B = null, this.Cn = null, this.h = null, this.C = null, this.j = null, this.Cs = null, this.Ea = "", this.isInitialized = !1, this.Ia = !1, this.Sa = new u(), this.Na = new u(), this.options = {}, this.Oa = [], this.Ta = [], this.yi = [], this.Xh = "6.2.0";
  }
  _createClass(Jt, [{
    key: "Ra",
    value: function Ra(t) {
      this.Sa.wt(t);
    }
  }, {
    key: "mh",
    value: function mh(t) {
      this.Na.wt(t);
    }
  }, {
    key: "initialize",
    value: function initialize(t, i) {
      var _this = this;
      if (this.ao()) return E.info("Braze has already been initialized with an API key."), !0;
      this.options = i || {};
      var e = this.ee(z.Yo);
      var r = ll(no.Ca());
      if (r && "true" === r.brazeLogging && (e = !0), E.init(e), E.info("Initialization Options: ".concat(JSON.stringify(this.options, null, 2))), null == t || "" === t || "string" != typeof t) return E.error("Braze requires a valid API key to be initialized."), !1;
      this.sn = t;
      var n = this.ee(z.Ro);
      if (null == n || "" === n || "string" != typeof n) return E.error("Braze requires a valid baseUrl to be initialized."), !1;
      !1 === /^https?:/.test(n) && (n = "https://".concat(n));
      var o = n;
      if (n = document.createElement("a"), n.href = o, "/" === n.pathname && (n = "".concat(n, "api/v3")), this.Ea = n.toString(), ro.Pa && !this.ee(z._o)) return E.info("Ignoring activity from crawler bot " + navigator.userAgent), this.Ia = !0, !1;
      var h = this.ee(z.Wo) || !1;
      if (this.j = Gt.La(t, h), h && this.j.Da(t), new ee.ne(null, !0).br(s.ie)) return E.info("Ignoring all activity due to previous opt out"), this.Ia = !0, !1;
      var _iterator = _createForOfIteratorHelper(C(this.options)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t5 = _step.value;
          -1 === Pt($t).indexOf(_t5) && E.warn("Ignoring unknown initialization option '".concat(_t5, "'."));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var a = ["mparticle", "wordpress", "tealium"];
      if (null != this.ee(z.Yh)) {
        var _t2 = this.ee(z.Yh);
        -1 !== a.indexOf(_t2) ? this.Zh = _t2 : E.error("Invalid sdk flavor passed: " + _t2);
      }
      var l = this.ee($t.Vo);
      if (null != l) if (D(l)) {
        var _t3 = [];
        for (var _i = 0; _i < l.length; _i++) ta(DeviceProperties, l[_i], "devicePropertyAllowlist contained an invalid value.", "DeviceProperties") && _t3.push(l[_i]);
        l = _t3;
      } else E.error("devicePropertyAllowlist must be an array. Defaulting to all properties."), l = null;
      var c = this.ee(z.Jh);
      if (c) {
        var _t4 = new _t(c);
        this.j.uu(s.iu.Jh, _t4);
      }
      this.on = new Ot(this.j, l), this.h = new Vt(this.j), this.Cs = new bt(this.h, this.j), this.C = new Kt(this.j, this.Cs, this.h, this.ee(z.Wh));
      var f = new u();
      return this.Qh = new Bt(this.j, this.ee(z.Xo), f), this.q(f), this.B = new Mt(this.on, this.j, this.Qh, this.Cs, this.C, this.h, this.sn, this.Ea, this.Xh, this.Zh || "", this.ee(z.Vh), this.ee(z.Kh)), this.Cn = new Wt(this.sn, this.Ea, this.C, this.on, this.Cs, this.h, this.j, function (t) {
        if (_this.ao()) {
          var _iterator2 = _createForOfIteratorHelper(_this.lr()),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _i2 = _step2.value;
              _i2.N(t);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }, this.Qh, this.B), this.Cn.initialize(), h || this.j.Ua(), E.info("Initialized for the Braze backend at \"".concat(this.ee(z.Ro), "\" with API key \"").concat(this.sn, "\".")), rt.t(), this.h.Ue(function () {
        var t;
        _this.isInitialized && (null === (t = _this.h) || void 0 === t ? void 0 : t.Re()) && import("../FeatureFlags/refresh-feature-flags.js").then(function (t) {
          if (!_this.isInitialized) return;
          (0, t["default"])();
        });
      }), this.Cn.rn(function () {
        var t;
        _this.isInitialized && (null === (t = _this.h) || void 0 === t ? void 0 : t.Re()) && import("../FeatureFlags/refresh-feature-flags.js").then(function (t) {
          if (!_this.isInitialized) return;
          (0, t["default"])(void 0, void 0, !0);
        });
      }), this.Sa.L(this.options), this.isInitialized = !0, window.dispatchEvent(new CustomEvent("braze.initialized")), !0;
    }
  }, {
    key: "destroy",
    value: function destroy(t) {
      if (E.destroy(), this.ao()) {
        this.Na.L(), this.Na.removeAllSubscriptions();
        var _iterator3 = _createForOfIteratorHelper(this.Oa),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _t6 = _step3.value;
            _t6.destroy();
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        this.Oa = [];
        var _iterator4 = _createForOfIteratorHelper(this.Ta),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _t7 = _step4.value;
            _t7.clearData(!1);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        this.B && this.B.fo(), this.Ta = [], this.removeAllSubscriptions(), this.yi = [], null != this.Cn && this.Cn.destroy(), this.Cn = null, this.Qh = null, this.on = null, this.B = null, this.h = null, this.C = null, this.Cs = null, this.options = {}, this.Zh = void 0, this.isInitialized = !1, this.Ia = !1, t && (this.j = null);
      }
    }
  }, {
    key: "rr",
    value: function rr() {
      return !this.Wa() && (!!this.ao() || (console.warn(w), !1));
    }
  }, {
    key: "ba",
    value: function ba() {
      return this.sn;
    }
  }, {
    key: "Sr",
    value: function Sr() {
      return this.Qh;
    }
  }, {
    key: "V",
    value: function V() {
      return this.Ea;
    }
  }, {
    key: "de",
    value: function de() {
      return this.on;
    }
  }, {
    key: "m",
    value: function m() {
      return this.B;
    }
  }, {
    key: "ee",
    value: function ee(t) {
      return this.options[t];
    }
  }, {
    key: "lr",
    value: function lr() {
      return this.Ta;
    }
  }, {
    key: "nn",
    value: function nn() {
      return this.Cn;
    }
  }, {
    key: "l",
    value: function l() {
      return this.h;
    }
  }, {
    key: "u",
    value: function u() {
      return this.C;
    }
  }, {
    key: "p",
    value: function p() {
      return this.j;
    }
  }, {
    key: "gr",
    value: function gr() {
      if (this.Cs && this.Cn) return new User(this.Cs, this.Cn);
    }
  }, {
    key: "ir",
    value: function ir() {
      return this.Cs;
    }
  }, {
    key: "tr",
    value: function tr() {
      return !0 === this.ee(z.re);
    }
  }, {
    key: "g",
    value: function g(t) {
      var i = !1;
      var _iterator5 = _createForOfIteratorHelper(this.Oa),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _s = _step5.value;
          _s === t && (i = !0);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      i || this.Oa.push(t);
    }
  }, {
    key: "v",
    value: function v(i) {
      var s = !1;
      var _iterator6 = _createForOfIteratorHelper(this.Ta),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _t8 = _step6.value;
          _t8.constructor === i.constructor && (s = !0);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      i instanceof t && !s && this.Ta.push(i);
    }
  }, {
    key: "q",
    value: function q(t) {
      t instanceof u && this.yi.push(t);
    }
  }, {
    key: "removeAllSubscriptions",
    value: function removeAllSubscriptions() {
      if (this.rr()) {
        var _iterator7 = _createForOfIteratorHelper(this.yi),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _t9 = _step7.value;
            _t9.removeAllSubscriptions();
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }
    }
  }, {
    key: "removeSubscription",
    value: function removeSubscription(t) {
      if (this.rr()) {
        var _iterator8 = _createForOfIteratorHelper(this.yi),
          _step8;
        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var i = _step8.value;
            i.removeSubscription(t);
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }
    }
  }, {
    key: "ce",
    value: function ce(t) {
      this.Ia = t;
    }
  }, {
    key: "ao",
    value: function ao() {
      return this.isInitialized;
    }
  }, {
    key: "Wa",
    value: function Wa() {
      return this.Ia;
    }
  }, {
    key: "Vs",
    value: function Vs() {
      return this.Xh;
    }
  }]);
  return Jt;
}();
var r = new Jt();
export { r as default, Jt as BrazeSdkInstance, z as OPTIONS };